<template>
    <q-page class="main">
        <div class="row justify-center items-center" :class="{'q-pa-md': !$isDesktop }">
            <q-card class="col-12 col-md-8">
                <q-card-section :class="$isDesktop ? 'q-pa-xl' : 'q-pa-lg'">
                    <extraInformation />
                </q-card-section>
                <q-card-actions align="between" :class="$isDesktop ? 'q-pa-xl' : 'q-pa-lg'">
                    <flat-button align="left" label="Terug"
                                 icon="arrow_circle_left"
                                 outline
                                 @click="$goto('homepage')" />
                    <primary-button align="left" label="Zoek richtlijnen" icon="search"
                                    @click="$goto('search.start')" />
                </q-card-actions>
            </q-card>
        </div>
    </q-page>
</template>

<script>
import { config } from '~INSTANCE'
import { defineAsyncComponent } from 'vue'

export default {
    components: {
        extraInformation: config.extraInformation,
    },
}
</script>
